import { Module, ParameterValue } from '@philips-internal/oswald-ui-foundation/lib/context';

export interface ParametersModule {
  cdFunction: string;
  name: string;
  parameters: Map<string, ParameterValue>;
}

function availableModulesMapper(tasyParameters: ParametersModule[], twsParameters: ParametersModule[]) : Module[] {

  function getParameters(parameters: Map<string, ParameterValue>): Map<string, ParameterValue> {
    const parametersMap: Map<string, ParameterValue> = new Map();

    if (parameters) {
      for (const [key, value] of Object.entries(parameters)) {
        parametersMap.set(key, value);
      }
    }

    return parametersMap;
  }

  const modules: Module[] = twsParameters.map((twsParam: ParametersModule) => ({
    id: twsParam.cdFunction,
    name: twsParam.name,
    parameters: getParameters(twsParam.parameters)
  }));

  tasyParameters.forEach( tasyParam => {
    const data = {
      id: tasyParam.cdFunction,
      name: tasyParam.name,
      parameters: getParameters(tasyParam.parameters)
    }

    modules.push(data);
  });

  return modules;

}

export {
  availableModulesMapper
}